(function () {
	'use strict';
	angular.module('smb-app')
		.factory('smbToolbarService',
		[
			'pxAuthService',
			ToolbarService
		]);
	/**
    * @ngdoc service
    * @name  smb-app.smbToolbarService
    * 
    * @description 
    * A service used to retrieve and interact with ShareBase app 
    * content toolbar
    * 
    **/
	function ToolbarService(pxAuthService) {
		var _title = null;
		var _backArrowState = 'content.home';
		var _showLogo = false;
		var _showContextMenu = false;
		var _contextMenuActions = [];
		var _backArrowStateParams = null;

		return {
			/**
            * @ngdoc property
            * @name smbToolbarService#title
            * @propertyOf smb-app.smbToolbarService
            * @kind property
            *
            * @description
            * Title assigned to content toolbar
            *
            * @returns {string} value of title 
            * 
            */
			get title() { return _title; },
			
			/**
            * @ngdoc property
            * @name smbToolbarService#title
            * @propertyOf smb-app.smbToolbarService
            * @kind property
            *
            * @description
            * Set the title for content toolbar
            *
            * @returns {string} value of title 
            * @param {string} val Title to assign to content toolbar 
            */
			set title(val) { _title = val; },

			/**
            * @ngdoc property
            * @name smbToolbarService#backArrowState
            * @propertyOf smb-app.smbToolbarService
            * @kind property
            *
            * @description
            * Get the state assigned to back arrow on the toolbar
            *
            * @returns {string} value of title 
            * 
            */
			get backArrowState() { return _backArrowState; },

			/**
            * @ngdoc property
            * @name smbToolbarService#backArrowState
            * @propertyOf smb-app.smbToolbarService
            * @kind property
            *
            * @description
            * Set the state to back arrow on the toolbar
            *
            * @returns {string} value of backArrowState 
            * @param {string} val Back Arrow State to assign to content toolbar 
            */
			set backArrowState(val) { _backArrowState = val; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#backArrowState
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Get the state params object for the toolbar's back button.
			 * 
			 * @returns {Object} State parameters for back button
			 */
			get backArrowStateParams() { return _backArrowStateParams; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#backArrowStateParams
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Optionally set stat parameters for the back arrow state.
			 * 
			 * @param {Object} val An object of state parameters
			 */
			set backArrowStateParams(val) { _backArrowStateParams = val; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#hasUserAdminRights
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Returns true if the current user has user administration rights
			 * 
			 * @returns {Boolean} Returns true if user is a user admin and false otherwise
			 */
			get hasUserAdminRights() { return pxAuthService.isUserAdmin || pxAuthService.isSiteAdmin; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#hasContentAdminRights
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Returns true if the current user has content administration rights
			 * 
			 * @returns {Boolean} Returns true if user has correct rights for content administration
			 * and false if they do not.
			 */
			get hasContentAdminRights() { return pxAuthService.isSiteAdmin; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#showLogo
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Returns true if the app logo should be displayed.
			 * 
			 * @returns {Boolean} True if the toolbar should display and false if
			 * it should hide the logo.
			 */
			get showLogo() { return _showLogo; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#showLogo
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Set the flag to show or hide the application logo
			 * 
			 * @param {Boolean} val Value to set the flag to
			 */
			set showLogo(val) { _showLogo = val; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#showBackButton
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Flag that determines if the toolbar will display the back button.
			 * If true, the back button will be displayed.
			 * 
			 * @returns {Boolean} True if the back button should be displayed and false
			 * if it should be hidden.
			 */
			get showBackButton() { return !_showLogo; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#showContextMenu
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Flag that returns true if the context menu is displayed and false if it
			 * is not. Defaults to false to hide the context menu.
			 * 
			 * @returns {Boolean} True if the context menu is displayed and false if
			 * it is hidden.
			 */
			get showContextMenu() { return _showContextMenu; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#showContextMenu
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Set the flag that determine whether to display or hide the context 
			 * menu
			 * 
			 * @param {Boolean} val Value to set the flag to.
			 */
			set showContextMenu(val) { _showContextMenu = val; },

			/**
			 * @ngdoc property
			 * @name smbToolbarService#contextMenuActions
			 * @propertyOf smb-app.smbToolbarService
			 * @kind property
			 * 
			 * @description
			 * Get the list of action objects for the context menu.
			 * 
			 * @returns {Object[]} Collection of context menu actions
			 */
			get contextMenuActions() { return _contextMenuActions; },

			/**
			 * @ngdoc method
			 * @name smbToolbarService#reset
			 * @methodOf smb-app.smbToolbarService
			 * @kind function
			 * 
			 * @description
			 * Reset the state of the toolbar service to all default values.
			 */
			reset: reset,

			/**
			 * @ngdoc method
			 * @name smbToolbarService#addContextMenuAction
			 * @methodOf smb-app.smbToolbarService
			 * @kind function
			 * 
			 * @description
			 * Add a new context menu action to the existing list of context menu actions.
			 * 
			 * @param {Object} action The content menu action to add
			 */
			addContextMenuAction: addContextMenuAction,

			/**
			 * @ngdoc method
			 * @name smbToolbarService#set
			 * @methodOf smb-app.smbToolbarService
			 * @kind function
			 * 
			 * @description
			 * Set the state of the toolbar service properties.
			 * 
			 * @param {String} title Title to display in toolbar
			 * @param {String} backArrow Target state for the back arrow
			 * @param {Boolean} showLogo Flag that indicates if the logo should be shown
			 * @param {Boolean} showContextMenu Flag that indicates if the context menu should be shown
			 */
			set: set,

			/**
			 * @ngdoc method
			 * @name smbToolbarService#setContextMenuActions
			 * @methodOf smb-app.smbToolbarService
			 * @kind function
			 * 
			 * @description
			 * Replace the current set of context menu actions with a new
			 * collection of actions
			 * 
			 * @param {Object[]} actions An array of context menu action objects
			 */
			setContextMenuActions: setContextMenuActions
		};

		function addContextMenuAction(action) {
			_contextMenuActions = _contextMenuActions.concat(action);
		}

		function setContextMenuActions(actions) {
			if (actions) {
				_contextMenuActions = actions;
			} else {
				_contextMenuActions = [];
			}
		}

		function reset() {
			set('', 'content.home', true, false);
		}

		function set(title, backArrow, showLogo, showContextMenu) {
			if (typeof title === 'string') {
				_title = title;
			}

			if (backArrow) {
				_backArrowState = backArrow;
			}

			_showLogo = showLogo;
			_showContextMenu = showContextMenu;
		}
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/services/toolbarService.js
// module id = 161
// module chunks = 1